package devxertech.com.pages.dashboard.ratingSection

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.CommonButton
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res
import kotlinx.browser.window
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun RatingSection(breakpoint: Breakpoint) {
    val sitePalette = ColorMode.current.toSitePalette()
    val ctx = rememberPageContext()

    val screenWidth = window.innerWidth
    val bannerWidth = 650
    val spacing = 100
    val scrollSpeed = 1

    val offset1 = remember { mutableStateOf(0) }
    val offset2 = remember { mutableStateOf(bannerWidth + spacing) }

    // Animate only if screen < 700
    if (screenWidth < 700) {
        LaunchedEffect(Unit) {
            while (true) {
                offset1.value -= scrollSpeed
                offset2.value -= scrollSpeed

                if (offset1.value <= -bannerWidth - spacing) {
                    offset1.value = offset2.value + bannerWidth + spacing
                }
                if (offset2.value <= -bannerWidth - spacing) {
                    offset2.value = offset1.value + bannerWidth + spacing
                }

                delay(10)
            }
        }
    }

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundColor(sitePalette.ratingSectionBackground.rgb)
            .overflow(Overflow.Hidden)
            .padding(topBottom = 15.px)
    ) {
        if (screenWidth < 700) {
            // ✅ MOBILE: Scrolling with button below
            Column(
                modifier = Modifier.fillMaxWidth().padding(leftRight = 5.percent),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Box(modifier = Modifier.fillMaxWidth().height(65.px),
                    contentAlignment = Alignment.Center) {
                    // First row
                    Row(
                        modifier = Modifier
                            .transform { translateX(offset1.value.px) }
                            .transition(Transition.of(TransitionProperty.All, 0.ms)),
                        horizontalArrangement = Arrangement.Center,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Image(src = Res.Image.google_rating, modifier = Modifier.width(228.px).height(54.px).padding(right = 20.px))
                        Image(src = Res.Image.trustpilot_rating, modifier = Modifier.width(380.px).height(38.px).padding(right = 20.px))
                    }
                    // Second row
                    Row(
                        modifier = Modifier
                            .transform { translateX(offset2.value.px) }
                            .transition(Transition.of(TransitionProperty.All, 0.ms)),
                        horizontalArrangement = Arrangement.Center,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Image(src = Res.Image.google_rating, modifier = Modifier.width(228.px).height(54.px).padding(right = 20.px))
                        Image(src = Res.Image.trustpilot_rating, modifier = Modifier.width(380.px).height(38.px).padding(right = 20.px))
                    }
                }

                // ⬇️ Button below
                CommonButton(
                    "Get Free Quote",
                    onClick = { ctx.router.navigateTo("/contact-us") },
                    ratingSection = true
                )
            }
        } else {
            // ✅ DESKTOP: Static with button in row
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceAround
            ) {
                Image(src = Res.Image.google_rating, modifier = Modifier.width(228.px).height(54.px).padding(right = 20.px))
                Image(src = Res.Image.trustpilot_rating, modifier = Modifier.width(380.px).height(38.px).padding(right = 20.px))
                CommonButton(
                    "Get Free Quote",
                    onClick = { ctx.router.navigateTo("/contact-us") },
                    ratingSection = true
                )
            }
        }
    }
}







//@Composable
//fun RatingSection(breakpoint: Breakpoint) {
//    val sitePalette = ColorMode.current.toSitePalette()
//    val ctx = rememberPageContext()
//    val scrollState = remember { mutableStateOf(0) }
//    val scrollAmount = 5
//    val duration = 50
//    val bannerWidth = 650
//    val spacingBetween = 100
//    val scrollSpeed = 1
//    val delayMillis = 10
//
//    val offset1 = remember { mutableStateOf(0) }
//    val offset2 = remember { mutableStateOf(bannerWidth + spacingBetween) }
//
//
//    LaunchedEffect(Unit) {
//        val screenWidth = window.innerWidth
//        if (screenWidth < 700) {
//            animateScroll(offset1, offset2, bannerWidth, spacingBetween, speed = 1)
//        }
//    }
//
//
//
////    if (screenWidth < 700) {
////        LaunchedEffect(Unit) {
////            while (true) {
////                for (i in 0 until 1000) {
////                    delay(duration.toLong())
////                    scrollState.value += scrollAmount
////
////
////                    if (scrollState.value > 1000) {
////                        scrollState.value = 0
////                    }
////                }
////                delay(1000)
////            }
////        }
////    }
//    Box(
//        modifier = Modifier.fillMaxWidth().backgroundColor(sitePalette.ratingSectionBackground.rgb)
//            .overflow(Overflow.Hidden)
//    ) {
//        if (window.screen.width < 700) {
//            Column(
//                modifier = Modifier.fillMaxWidth().padding(leftRight = 5.percent)
//                    .margin(topBottom = 5.px),
//                horizontalAlignment = Alignment.CenterHorizontally
//            ) {
//                Box(modifier = Modifier.fillMaxWidth().padding(topBottom = 8.px)) {
//                    Row(
//                        modifier = Modifier
//                            .transform { translateX(offset1.value.px) }
//                            .transition(Transition.of(TransitionProperty.All, 0.ms)),
//                        verticalAlignment = Alignment.CenterVertically
//                    ) {
//                        Image(
//                            src = Res.Image.google_rating,
//                            modifier = Modifier.width(228.px).height(54.px).padding(right = 20.px)
//                        )
//                        Image(
//                            src = Res.Image.trustpilot_rating,
//                            modifier = Modifier.width(380.px).height(38.px).padding(right = 20.px)
//                        )
//                    }
//
//                    // Second strip — appears only when 25% of first is off screen
//                    Row(
//                        modifier = Modifier
//                            .transform { translateX(offset2.value.px) }
//                            .transition(Transition.of(TransitionProperty.All, 0.ms)),
//                        verticalAlignment = Alignment.CenterVertically
//                    ) {
//                        Image(
//                            src = Res.Image.google_rating,
//                            modifier = Modifier.width(228.px).height(54.px).padding(right = 20.px)
//                        )
//                        Image(
//                            src = Res.Image.trustpilot_rating,
//                            modifier = Modifier.width(380.px).height(38.px).padding(right = 20.px)
//                        )
//                    }
//                }
//                CommonButton(
//                    "Get Free Quote",
//                    onClick = { ctx.router.navigateTo("/contact-us") },
//                    ratingSection = true
//                )
//            }
//
//        } else {
//            Row(
//                modifier = Modifier.fillMaxWidth().padding(16.px),
//                verticalAlignment = Alignment.CenterVertically,
//                horizontalArrangement = Arrangement.SpaceAround
//            ) {
//                Image(
//                    src = Res.Image.google_rating,
//                    modifier = Modifier.width(228.px).height(44.px).margin(left = (-40).px)
//                )
//                Image(
//                    src = Res.Image.trustpilot_rating,
//                    modifier = Modifier.width(380.px).height(38.px).margin(right = 30.px)
//                )
//                CommonButton(
//                    "Get Free Quote",
//                    onClick = { ctx.router.navigateTo("/contact-us") },
//                    ratingSection = true
//                )
//            }
//        }
//
//
////        Row (modifier = Modifier.fillMaxWidth().margin(topBottom = 10.px).flexWrap(if(screenWidth > 700) FlexWrap.Wrap else FlexWrap.Nowrap)
////            .transform { translateX(-scrollState.value.px) },
////            verticalAlignment = Alignment.CenterVertically,
////            horizontalArrangement = Arrangement.SpaceAround,
////            ){
////            Image(src = Res.Image.google_rating, modifier = Modifier.width(228.px).height(64.px).padding(right = 10.px))
////            Image(src = Res.Image.trustpilot_rating, modifier = Modifier.width(380.px).height(38.px))
////        if (window.screen.width > 700) {
////            CommonButton(
////                "Get Free Quote",
////                onClick = { ctx.router.navigateTo("/contact-us") },
////                ratingSection = true
////            )
////        }
////
////        if (window.screen.width < 700) {
////            CommonButton(
////                "Get Free Quote",
////                onClick = { ctx.router.navigateTo("/contact-us") },
////                ratingSection = true
////            )
////        }
//    }
//}
//
//
//fun animateScroll(
//    offset1: MutableState<Int>,
//    offset2: MutableState<Int>,
//    bannerWidth: Int,
//    spacing: Int,
//    speed: Int,
//) {
//    fun frameLoop() {
//        offset1.value -= speed
//        offset2.value -= speed
//
//        if (offset1.value <= -bannerWidth - spacing) {
//            offset1.value = offset2.value + bannerWidth + spacing
//        }
//        if (offset2.value <= -bannerWidth - spacing) {
//            offset2.value = offset1.value + bannerWidth + spacing
//        }
//
//        window.requestAnimationFrame { frameLoop() }
//    }
//
//    frameLoop()
//}
